module.exports = __webpack_public_path__ + "static/original-desktop-f3559b7937b7738e1867b425b4785234.jpg";